var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import WindowEventContext from '../../context/window-event-context';
import { getGeometryStyle, getMinimumHeight, getMinimumWidth } from '../../helpers/styles';
import useFormItem from '../../hooks/useFormItem';
import Label from '../Label';
var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + ";\n  min-width: " + getMinimumWidth(minimumSize) + ";";
};
var StyledCheckboxContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  align-items: ", ";\n  ", "\n  ", "\n  text-align: ", ";\n  background: ", ";\n"], ["\n  display: ", ";\n  align-items: ", ";\n  ", "\n  ", "\n  text-align: ", ";\n  background: ", ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.alignItems;
}, function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return minimumSize && getMinHeightWidth(minimumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.textAlign;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.backgroundColor;
});
export var StyledCheckbox = styled.input.attrs(function (props) { })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: ", ";\n  margin: ", ";\n  width: ", ";\n  height: ", ";\n  &::before\n    ", "\n    &::after\n    ", "\n    :not(:checked) {\n    &:after {\n      opacity: ", ";\n    }\n  }\n  :checked: {\n    appearance: ", ";\n    background-color: ", ";\n  }\n  ", "\n"], ["\n  min-width: ", ";\n  margin: ", ";\n  width: ", ";\n  height: ", ";\n  &::before\n    ", "\n    &::after\n    ", "\n    :not(:checked) {\n    &:after {\n      opacity: ",
    ";\n    }\n  }\n  :checked: {\n    appearance: ",
    ";\n    background-color: ",
    ";\n  }\n  ",
    "\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.input.minWidth;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.input.margin;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.input.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.input.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.before;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.after;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme.checkbox.input.checked) === null || _b === void 0 ? void 0 : _b.opacity;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.input.checked.appearance;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.input.checked.backgroundColor;
}, function (_a) {
    var checked = _a.checked, windowTheme = _a.windowTheme;
    return "\n        appearance: " + (checked
        ? windowTheme.checkbox.input.checked.appearance
        : windowTheme.checkbox.input.appearance) + ";      \n        background: " + (checked
        ? windowTheme.checkbox.input.checked.background
        : windowTheme.checkbox.input.background) + ";\n        \n    ";
});
var StyledLabel = styled(Label).attrs(function (props) { })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: ", ";\n  border: ", ";\n  align-items: ", ";\n  color: ", ";\n"], ["\n  margin-left: ", ";\n  border: ", ";\n  align-items: ", ";\n  color: ", ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.label.marginLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.label.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.label.alignItems;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.checkbox.label.color;
});
var Checkbox = function (props) {
    var attributes = props.attributes, identifier = props.identifier, type = props.type, children = props.children, className = props.className, restProps = __rest(props, ["attributes", "identifier", "type", "children", "className"]), text = attributes.text, enabled = attributes.enabled, checkable = attributes.checkable, minimumSize = attributes.minimumSize, geometry = attributes.geometry, disabled = enabled === 'false' || checkable === 'false';
    var value = useFormItem(identifier, {
        extractor: function (evt) { return evt.target.checked; },
    }).value;
    var _onFieldUpdate = useContext(WindowEventContext)._onFieldUpdate;
    return (React.createElement(StyledCheckboxContainer, __assign({}, attributes, { minimumSize: minimumSize, className: className }, restProps),
        React.createElement(StyledCheckbox, __assign({ type: "checkbox", id: identifier, geometry: geometry }, restProps, { disabled: disabled, checked: value || false, onChange: function (evt) {
                _onFieldUpdate(identifier, evt.target.checked);
            } })),
        React.createElement(StyledLabel, { attributes: { text: text }, windowTheme: restProps.windowTheme })));
};
export default Checkbox;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map